// extracted by mini-css-extract-plugin
export default {"formField":"styles_formField__lNkND","space":"styles_space__lkH43","deadlineInputsContainer":"styles_deadlineInputsContainer__7lmKc"};